module.exports = __webpack_public_path__ + "static/media/whats-hireed.bd4d35b5.jpg";